import { AxiosError } from 'axios';
import { OutputWrapperInterface } from '../interfaces/common';

export function ErrorWrapperHandler<T>(
  error: unknown
): OutputWrapperInterface<T> {
  const message = 'Something went wrong.';
  let res: OutputWrapperInterface<T> = {
    status: false,
    message: message,
  };


  if (error instanceof AxiosError) {

    if (error.response && error.response.data) {
      const errorResponse = error.response.data as OutputWrapperInterface<T>;
      res = errorResponse;
    } else {
      res.message = message;
    }
  } else {
    res.message = message;
  }

  return res;
}
